export default "__VITE_ASSET__Bq6vj1kC__"